import api from '../api';
const authUrl = process.env.REACT_APP_AUTH_API_URL;

const getAllCompanies = async (keycloakToken) => {
    try {
        const { data } = await api.get(`${authUrl}/companies`, {
            headers: {
                'Authorization': `Bearer ${keycloakToken}`,
            },
        });

        return data;
    } catch (error) {
        console.error("Error to get all companies", error);
        throw new Error(error?.response?.data?.message || "Erro ao buscar empresas");
    }
}

const createCompany = async (name, sector, keycloakToken) => {
    try {
        const { data } = await api.post(
            `${authUrl}/companies`,
            { name, sector },
            {
                headers: {
                    'Authorization': `Bearer ${keycloakToken}`,
                },
            }
        );
        
        return data;
    } catch (error) {
        console.error("Error to create company", error);
        throw new Error(error?.response?.data?.message || "Erro ao criar empresa");
    }
}

export default { getAllCompanies, createCompany };